var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Container, Stack, Link, Text } from "@bookingcom/bui-react";
import "@bookingcom/bui-react/types/global";
import classNames from "../../../utilities/classNames";
import styles from "../TravellerFooter.module.css";
import "../TravellerFooter.types";
var InlineLinksList = function (_a) {
    var items = _a.items, variant = _a.variant, linkTextVariant = _a.linkTextVariant, attributes = _a.attributes;
    return (React.createElement("div", __assign({ className: styles["inline-links-list--".concat(variant)] }, attributes),
        React.createElement(Container, { centered: true, className: styles["inline-links-list--content"] },
            React.createElement(Stack, { direction: "row", gap: 3 }, items.map(function (item) { return (React.createElement(Link, { key: item.text, href: item.href, text: React.createElement(Text, { variant: linkTextVariant }, item.text), variant: "secondary", className: classNames(styles["inline-links-list-item"], item.className), attributes: item.attributes, onClick: item.onClick })); })))));
};
export default InlineLinksList;
